import { gql } from 'apollo-angular';

export const outdatedOperationDocumentsQuery = gql`
  query outdatedOperationDocuments($operationGroupId: Int!) {
    outdatedOperationDocuments(operationGroupId: $operationGroupId) {
      fichierOperationId
      operationId
      natureDocumentRequisId
      categoryId
      estCoInvestisseur
      currentFileId
      currentFileName
      currentVersionNumber
      latestFileId
      latestFileName
      latestVersionNumber
    }
  }
`;
